var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 9.73958V7.38C15.3125 5.37521 13.6873 3.75 11.6825 3.75H8.005C6.00021 3.75 4.375 5.3752 4.375 7.38V12.62C4.375 14.6248 6.00021 16.25 8.005 16.25H9.0625",
    stroke: "#AB9D96",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7268 15.4726L15.5763 13.6232C15.7794 13.4201 15.7794 13.0912 15.5763 12.8886L14.7523 12.0647C14.5492 11.8616 14.2204 11.8616 14.0178 12.0647L12.1683 13.9141C12.0707 14.0118 12.0161 14.1437 12.0161 14.2814V15.6249H13.3595C13.4972 15.6249 13.6292 15.5703 13.7268 15.4726Z",
    stroke: "#AB9D96",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H12.5",
    stroke: "#AB9D96",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10H10.625",
    stroke: "#AB9D96",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H9.375",
    stroke: "#AB9D96",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.56e94ac9d8ab0e279e46057e15b94d18.svg";
export { ForwardRef as ReactComponent };